import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class OnshapeConfigurationEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "OnshapeConfiguration";
        this.primaryEnterpriseComponent = "OnshapeConfiguration";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "OnshapeConfiguration";
        eom.enterpriseComponent = "OnshapeConfiguration";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default OnshapeConfigurationEnterpriseObjectMetadata;